/* eslint-disable */

import Script from 'next/script';
import React from 'react';

const getNaverSearch = () => (
  <Script
    key="naver-search-js"
    type="text/javascript"
    src="https://wcs.naver.net/wcslog.js"
  />
);

const runNaverSearch = () => {
  if (window.wcs != null) {
    if (!window.wcs_add) window.wcs_add = {};
    window.wcs_add['wa'] = 's_2e85116be219';
    if (!_nasa) var _nasa = {};
    wcs.inflow('ohou.se');
    wcs_do(_nasa);
  }
};

const getKakaoMomentScript = () => (
  <Script
    key="kakao-moment-js"
    type="text/javascript"
    charset="UTF-8"
    src="//t1.daumcdn.net/adfit/static/kp.js"
  ></Script>
);

const runKakaoMomentScript = () => {
  if (window.kakaoPixel != null) {
    kakaoPixel('7919701595446099671').pageView();
  }
};

export const getMarketingFooterScript = () => {
  const isProduction = process.env.NODE_ENV === 'production';

  const scriptList = [];
  if (isProduction) {
    scriptList.push(getNaverSearch());
    scriptList.push(getKakaoMomentScript());
  }
  return scriptList;
};

export const runMarketingFooterScript = () => {
  const isProduction = process.env.NODE_ENV === 'production';

  if (isProduction) {
    runNaverSearch();
    runKakaoMomentScript();
  }
};
